import { useState, useEffect, useCallback } from "react";
import freeMessagesService from "../api/freeMessagesApi";
import { useAppSelector } from "../redux/typedHooks";
import { UserInterface } from "../types/user";

interface FreeMessagesStatus {
  isViewer: boolean;
  freeMessagesUsed: number;
  freeMessagesRemaining: number;
  lastReset: string;
}

interface CanSendResponse {
  canSend: boolean;
  reason: string;
  status?: FreeMessagesStatus;
}

export const useFreeMessages = () => {
  const [status, setStatus] = useState<FreeMessagesStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const user = useAppSelector<UserInterface | null>(
    state => state.user.currentUser
  );

  const fetchStatus = useCallback(async () => {
    if (!user) return
    try {
      setLoading(true);
      setError(null);
      const response = await freeMessagesService.getStatus();
      setStatus(response);
    } catch (err) {
      console.error("Error fetching free messages status:", err);
      setError(
        (err as Error)?.message || "Failed to fetch free messages status"
      );
    } finally {
      setLoading(false);
    }
  }, [user]);

  const checkCanSend =
    useCallback(async (): Promise<CanSendResponse | null> => {
      try {
        const response = await freeMessagesService.canSend();
        return response as CanSendResponse;
      } catch (err) {
        console.error("Error checking if can send free message:", err);
        setError(
          (err as Error)?.message || "Failed to check if can send free message"
        );
        return null;
      }
    }, []);

  // const useFreeMessage = useCallback(async (): Promise<boolean> => {
  //   try {
  //     const response = await freeMessagesService.useFreeMessage();
  //     if (response.success) {
  //       // Update local status
  //       setStatus(prev =>
  //         prev
  //           ? {
  //               ...prev,
  //               freeMessagesUsed: response.freeMessagesUsed,
  //               freeMessagesRemaining: response.freeMessagesRemaining,
  //             }
  //           : null
  //       );
  //       return true;
  //     }
  //     return false;
  //   } catch (err) {
  //     console.error("Error using free message:", err);
  //     setError((err as Error)?.message || "Failed to use free message");
  //     return false;
  //   }
  // }, []);

  const refetch = useCallback(() => {
    fetchStatus();
  }, [fetchStatus]);

  useEffect(() => {
    fetchStatus();

    // // Update status every 5 minutes
    const interval = setInterval(fetchStatus, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [fetchStatus]);

  return {
    status,
    loading,
    error,
    refetch,
    checkCanSend,
    // useFreeMessage,
  };
};

export default useFreeMessages;
